/*
*###############################################################################
*Module Name                   : TicketMaster.js                               #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 1st 2022, 10:14:01 am          #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import TicketMasterContent from './TicketMasterContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { DecimalValidation, Numeric, Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import * as XLSX from "xlsx";
import DPPrintOption from 'framework/widgets/DPPrintOptions'
//**End Importing required componant files */

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { DeleteTicketMasterDetails, SaveTicketMasterDetails, TicketMasterDetailsGetData, SKU } from './TicketMasterController'

const TicketMaster = (props) => {

    let history = useHistory();
    //*** User input related states */
    const [strTicketCode, SetCode] = useState("");// Set Code
    const [strTicketDesc, SetDescription] = useState("")//Set Description
    const [IsActive, SetActive] = useState(true)//Set Active state
    const [ticketValue, setTicketValue] = useState(0.00)
    const [billValue, setBillValue] = useState(0.00)
    const [redeemBillValueFrom, setRedeemBillValueFrom] = useState(0.00)
    const [redeemBillValueTo, setRedeemBillValueTo] = useState(0.00)
    const [redeemFromDate, setRedeemFromDate] = useState("")
    const [redeemToDate, setRedeemToDate] = useState("")
    const [gridData, SetGridData] = useState([{
        id: 1,
        lineNo: 1,
        lineDesc: "",
        lineBold: false,
        lineUnderline: false,
    }])
    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    const [menuCode, SetMenuCode] = useState("")
    //*** End User activity related staes */

    //Alert Parameters
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*** Get and Set values when user search code */

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)

    const [valueUpload, setvalueUpload] = useState("")
    const [items, setItems] = useState([]);
    const [Excelitems, setExcelItems] = useState([]);

    const [currentPage, setCurrentPage] = useState(1)

    const [bundle, setBundle] = useState("");
    const [allBundle, setAllBundle] = useState([]);
    const [helpUrl, setHelpUrl] = useState("")
    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
    } = useContext(Context);
    //import from contexts

    var time = process.env.REACT_APP_ALERTTIMEOUT

    //**Get File Details */
    useEffect(async () => {
 
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        if (!responseData.strMenuAccessRight) {
            history.push('/dashboard')
        }

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)
        setHelpUrl(responseData.strHelpUrl)
        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

        const skuResponse = await SKU()
        setAllBundle(skuResponse)

    }, [strTicketCode])

    // AuditLog
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu =
            menuDetail && menuDetail.menuTag
                ? menuDetail.menuTag
                : history.push("/dashboard")

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
    }, [])



    const readExcel = (file) => {
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0];

                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);

                setExcelItems(data);
                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((d) => {
            setItems(d);
        });
    };

    //*** Get and Set values when user search code */
    async function getData(searchData) {

        // if (searchData == "") return

        if (validateSpecialCharacters(searchData) == true) {
            SetCode("")
            return
        }

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Fetching...")

        const result = await TicketMasterDetailsGetData(searchData);

        SetLoadingAlert(false)

        if (result.success == true) {

            var curremtTicketList = []

            SetDescription(result.data.name)
            SetActive(result.data.status)
            setBillValue(parseFloat(result.data.billValue).toFixed(2))
            setRedeemBillValueFrom(parseFloat(result.data.redeemBillValueFrom).toFixed(2))
            setRedeemBillValueTo(parseFloat(result.data.redeemBillValueTo).toFixed(2))
            setTicketValue(parseFloat(result.data.ticketValue).toFixed(2))
            setRedeemFromDate(result.data.fromDate.slice(0, 10) == "1900-01-01" ? "" : result.data.fromDate.slice(0, 10))
            setRedeemToDate(result.data.toDate.slice(0, 10) == "1900-01-01" ? "" : result.data.toDate.slice(0, 10))
            setCrBy(result.data.createdBy)
            setCrDate(result.data.createdDate)
            setMdBy(result.data.modifiedBy)
            setMdDate(result.data.modifiedDate == "01/01/1900" ? "" : result.data.modifiedDate)
            setCrEnable(true)
            setBundle(result.data.productBundle)

            curremtTicketList = result.data.ticketDetails

            setDisabled(true)
            setDisabledCode(true)
            setSaveEnable(false)
            SetAddNew(false)
            SetDeleteEnable(true)
            setSearchdisabled(true)
            setReason("Updated")
            SetEditEnable(true)

            if (curremtTicketList.length > 0) {

                var modifiedList = []
                curremtTicketList.map((item, index) => {
                    modifiedList.push({
                        "id": index + 1,
                        "lineNo": item.pticK_LINENO,
                        "lineDesc": item.pticK_DESC,
                        "lineBold": item.pticK_BOLD,
                        "lineUnderline": item.pticK_UNDLINE
                    })
                })
                SetGridData(modifiedList)

            } else {

                SetGridData([{
                    id: 1,
                    lineNo: 1,
                    lineDesc: "",
                    lineBold: false,
                    lineUnderline: false,

                }])
            }

        } else {
            displayAlertMessage('success', "Record Not Found !");
        }
    }
    //*** End useEffect */

    // print Function
    async function handlePrint(option) {
        const authToken = localStorage.getItem("authToken")
        var option = option

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/Ticket/report/${LogUserType}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (option == "PDF") {
                        {
                            const msg = responseData.msg
                            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                        }
                    }
                    if (option == "XCEL") {
                        {
                            const msg = responseData.msg
                            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                        }
                    }

                }
                SetLoadingAlert(false)
            }).catch(error => {
                console.log(error.message)
                SetLoadingAlert(false)
            })
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    //save button function
    const handlesave = async (e) => {

        const authToken = localStorage.getItem("authToken")

        //set autogenerate code to as CODE just for display purpuse
        var newCode = ""
        if (addNew == true && nullCode == false) {
            SetCode(autoCode)
            newCode = autoCode
        } else {
            newCode = strTicketCode
        }

        if (strTicketCode == "" && nullCode == true) {
            displayAlertMessage('danger', "Please Enter Designation Group Code !")
            return;
        }
        if (strTicketDesc == "") {
            displayAlertMessage('danger', "Please Enter description")
            return;
        }

        if (parseFloat(redeemBillValueFrom) != 0 || parseFloat(redeemBillValueTo) != 0) {
            if (parseFloat(redeemBillValueFrom) > parseFloat(redeemBillValueTo)) {
                displayAlertMessage('danger', "Redeem Bill Value From Should be Less Than Redeem Bill Value To")
                return;
            }
        }

        let TicketDet = []

        for (var i = 0; i < gridData.length; i++) {
            if (gridData[i].lineDesc === "") {
                displayAlertMessage('danger', "Please Enter Line Description For Line No " + gridData[i].lineNo);
                return; // stop processing on empty line
            }

            TicketDet.push({
                "PTICK_CODE": strTicketCode,
                "PTICK_LINENO": parseFloat(gridData[i].lineNo),
                "PTICK_DESC": gridData[i].lineDesc,
                "PTICK_BOLD": gridData[i].lineBold ? 1 : 0,
                "PTICK_UNDLINE": gridData[i].lineUnderline ? 1 : 0,
            });
        }


        var ActiveStat = IsActive == "1" ? true : false; //checking active sate

        const VenderDesignation = {
            "strTicketCode": newCode,
            "strTicketName": strTicketDesc,
            "IsActive": ActiveStat,
            "ticketValue": parseFloat(ticketValue),
            "billValue": parseFloat(billValue),
            "redeemBillValueFrom": parseFloat(redeemBillValueFrom),
            "redeemBillValueTo": parseFloat(redeemBillValueTo),
            "fromDate": redeemFromDate == "" ? "1900-01-01" : redeemFromDate,
            "toDate": redeemToDate == "" ? "1900-01-01" : redeemToDate,
            "TicketDetails": TicketDet,
            "strMenuCode": menuCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType,
            "blAddNew": addNew,
            "productBundle": bundle,

        }


        if (VenderDesignation.strTicketCode == "") {
            displayAlertMessage('danger', "Please Enter Ticket Code !")
            return;
        }

        //loading alert show
        SetLoadingAlert(true)
        if (addNew == true) {
            SetLoadingAlerttitle("Saving...")
        } else {
            SetLoadingAlerttitle("Updating...")
        }

        //*** save/update records */
        const result = await SaveTicketMasterDetails(VenderDesignation);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage("success", result.data)
            ClearItem()
        } else {
            displayAlertMessage("danger", result.data)
        }
    }
    //***save/update end */


    // //notification disable function
    // setTimeout(() => {
    //     setShow(false)
    // }, time)


    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        SetCode(row.PTICK_CODE);
        getData(row.PTICK_CODE)
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrEnable(true)
    }
    //*** End of getSelectedRow function */

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    //new button function
    const handleNew = e => {
        //e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = () => {

        SetCode("")
        SetDescription("")
        SetActive(true)
        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        setErrorMsg('')
        SetAddNew(true)
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetEditEnable(false)
        setSaveEnable(true)
        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        SetGridData([{
            id: 1,
            lineNo: 1,
            lineDesc: "",
            lineBold: false,
            lineUnderline: false,
        }])
        setCurrentPage(1)
        setTicketValue(0.00)
        setBillValue(0.00)
        setRedeemBillValueFrom(0.00)
        setRedeemBillValueTo(0.00)
        setRedeemFromDate("")
        setRedeemToDate("")
        setBundle("")
    }

    //********Delete button function */
    const handleDelete = async () => {

        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": strTicketCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType
        }

        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        const result = await DeleteTicketMasterDetails(rowDelete);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage("success", result.data)
            ClearItem()

        } else {

            displayAlertMessage("danger", result.data)
        }
    }
    //*********Delete button function end */


    //CODE AUTO GEN
    const AutoGenerateCode = async () => {
        const authToken = localStorage.getItem("authToken")
        const ApiURL = window.Links.ApiURL
        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetCode(responseData.data)
                        setAutoCode(responseData.data)
                    } else {
                        setDisabledCode(false)
                    }
                }
            })
    }


    //**Permission Check */
    const permission = (operation) => {
        const authToken = localStorage.getItem("authToken")
        const ApiURL = window.Links.ApiURL
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }


    //Function for displaying Alert Messages.

    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }

    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }


    const validateSpecialCharacters = (str) => {
        const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
        return specialCharRegex.test(str);
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {

                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                history.push('/dashboard')
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                            setShow(false)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <TicketMasterContent
                                            GetSelectRow={GetSelectRow}
                                            CodeValue={strTicketCode}
                                            CodeonChange={e => {
                                                let val1 = Text(
                                                    e.target,
                                                    5,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetCode(val1)
                                            }}
                                            DescValue={strTicketDesc}
                                            DescOnChange={e => {
                                                let val2 = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetDescription(val2)
                                            }}
                                            ActiveSw={IsActive}
                                            SwonChange={() => {
                                                SetActive(!IsActive)
                                            }}
                                            setTicketValue={(e) => {
                                                let tickVal = Numeric(e.target, 10, 2, false)
                                                setTicketValue(tickVal)
                                            }}
                                            setTicketValueOnBlur={(e) => {
                                                let tickVal = DecimalValidation(e.target.value, 0, true, 2)
                                                setTicketValue(tickVal)
                                            }}
                                            setBillValue={(e) => {
                                                let billVal = Numeric(e.target, 10, 2, false)
                                                setBillValue(billVal)
                                            }}
                                            setBillValueOnBlur={(e) => {
                                                let billVal = DecimalValidation(e.target.value, 0, true, 2)
                                                if (billVal > 100) {
                                                    setBillValue(DecimalValidation(100, 0, true, 2))
                                                } else {
                                                    setBillValue(billVal)
                                                }

                                            }}
                                            setRedeemBillValueFrom={(e) => {
                                                let billVal = Numeric(e.target, 10, 2, false)
                                                setRedeemBillValueFrom(billVal)
                                            }}
                                            setRedeemBillValueFromOnBlur={(e) => {
                                                let billVal = DecimalValidation(e.target.value, 0, true, 2)
                                                setRedeemBillValueFrom(billVal)
                                            }}
                                            setRedeemBillValueTo={(e) => {
                                                let billVal = Numeric(e.target, 10, 2, false)
                                                setRedeemBillValueTo(billVal)
                                            }}
                                            setRedeemBillValueToOnBlur={(e) => {
                                                let billVal = DecimalValidation(e.target.value, 0, true, 2)
                                                setRedeemBillValueTo(billVal)
                                            }}
                                            redeemBillValueFrom={redeemBillValueFrom}
                                            redeemBillValueTo={redeemBillValueTo}


                                            setRedeemFromDate={(e) => {
                                                setRedeemFromDate(e.target.value)
                                            }}
                                            setRedeemToDate={(e) => {
                                                setRedeemToDate(e.target.value)
                                            }}
                                            ticketValue={ticketValue}
                                            billValue={billValue}
                                            redeemFromDate={redeemFromDate}
                                            redeemToDate={redeemToDate}

                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}
                                            show={show}
                                            disabled={disabled}
                                            disabledCode={disabledCode}
                                            AlertColor={AlertColor}
                                            AlertMsg={AlertMsg}
                                            CodeOnBlur={e => {
                                                getData(e.target.value)
                                            }}
                                            ErrorMsg={ErrorMsg}
                                            menuName={menuName}
                                            onButtonClick={e => {
                                                AutoGenerateCode()
                                                setCodeButton(true)
                                            }}
                                            btnDisable={codeButton}
                                            SearchDisable={searchdisabled}
                                            showFileUpload={(e) => {
                                                const file = e.target.files[0];
                                                readExcel(file);
                                                setvalueUpload(e.target.value)
                                            }}
                                            valueUpload={valueUpload}
                                            DataRow={gridData}
                                            autoCode={autoCode}
                                            menuCode={menuCode}
                                            SetGridData={SetGridData}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}

                                            bundle={bundle}
                                            allBundle={allBundle}
                                            setBundle={e => { setBundle(e["value"]) }}




                                        />
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default TicketMaster